/*eslint-disable*/
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });
ScrollTrigger.normalizeScroll(true); // enable

export default function Animations() {
	function animateBlocks() {
		let endValue = document.querySelectorAll('.block-animation').length * 100 + '%';

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.main',
				start: 'top top',
				end: endValue,
				scrub: 1,
				pin: true,
				onUpdate: (self) => {
					if (self.progress === 1) {
						document.querySelector('footer').classList.add('end-scroll');
					} else {
						document.querySelector('footer').classList.remove('end-scroll');
					}
				},
			},
		});

		gsap.utils.toArray('.block-animation').forEach((block, i, blocks) => {
			block.style.zIndex = blocks.length + i;

			if (block.dataset.animation === 'from-left') {
				tl.fromTo(block, { xPercent: 100 }, { xPercent: 0, ease: 'none' }, i * 0.5);
			} else if (block.dataset.animation === 'from-bottom') {
				let toValue;
				let blockHeight = block.clientHeight;

				if (blockHeight > window.innerHeight) {
					toValue = window.innerHeight - block.clientHeight;
				} else {
					toValue = 0;
				}

				tl.fromTo(block, { y: blockHeight }, { y: toValue, ease: 'none' }, i * 0.5);
			}

			// Check if block has image reveal squares
			if (block.querySelector('.image-reveal')) {
				tl.addLabel(`blockStart${i}`, i * 0.5);
				gsap.utils.toArray('.image-reveal__square', block).forEach((square, j) => {
					let distance = -50 - j * 10;
					tl.fromTo(square, { opacity: 1 }, { yPercent: distance, scale: 0, ease: 'none' }, `blockStart${i}`);
				});
			}
		});

		let modal = document.querySelector('.c-modal');

		modal.addEventListener('wheel', function (e) {
			// prevent default scroll behavior
			e.preventDefault();
			// calculate new scroll position
			let scrollAmount = e.deltaY;

			// set the new scroll position
			modal.scrollTop += scrollAmount / 2;
		});

		let startTouchY;

		modal.addEventListener('touchstart', function (e) {
			// save the starting touch position
			startTouchY = e.touches[0].clientY;
		});

		modal.addEventListener('touchmove', function (e) {
			// prevent default scroll behavior
			e.preventDefault();

			// calculate the difference in the touch position
			let touchY = e.touches[0].clientY;
			let touchDifference = startTouchY - touchY;

			// set the starting touch position for the next touch move
			startTouchY = touchY;

			// calculate new scroll position
			let scrollAmount = touchDifference;

			// set the new scroll position
			modal.scrollTop += scrollAmount;
		});

		// get all .content-with-cta elements
		let contentBlocks = document.querySelectorAll('.content-with-cta');

		// iterate through each block
		if (!contentBlocks) return;
		contentBlocks.forEach((block) => {
			// find the .readmore-box__content element within the current block
			let readmoreBoxContent = block.querySelector('.readmore-box__content');

			if (!readmoreBoxContent) {
				return;
			}

			let modalContent = readmoreBoxContent.innerHTML; // Get the modal content

			// get button
			let btn = block.querySelector('.readmore-box__button');

			// bind button click to modal.open
			btn.addEventListener('click', function (ev) {
				ev.preventDefault();
				let modal = document.querySelector('.c-modal');

				if (modal.classList.contains('active')) {
					document.querySelector('.c-modal .c-modal__content').innerHTML = '';
					document.querySelector('body').classList.remove('overflow-hidden');
					tl.resume();
				} else {
					tl.pause();
					document.querySelector('.c-modal .c-modal__content').innerHTML = modalContent;
					//Open modal
					document.querySelector('.c-modal').classList.add('active');
					// Overflow on body
					document.querySelector('body').classList.add('overflow-hidden');
				}
			});
		});

		let closeModalButton = document.querySelector('.js-close-modal');

		if (!closeModalButton) {
			return;
		}

		closeModalButton.addEventListener('click', function (ev) {
			ev.preventDefault();
			document.querySelector('.c-modal').classList.remove('active');
			document.querySelector('body').classList.remove('overflow-hidden');
			tl.resume;
		});

		return tl;
	}
	let tl = animateBlocks(); // Call your function and store the ScrollTrigger instance
}
